const selectionCoversEntireEditable = (el) => {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) return false;
  const range = sel.getRangeAt(0);
  if (range.collapsed) return false;
  if (!el.contains(range.commonAncestorContainer)) return false;
  const full = document.createRange();
  full.selectNodeContents(el);
  return (
    range.compareBoundaryPoints(Range.START_TO_START, full) <= 0 &&
    range.compareBoundaryPoints(Range.END_TO_END, full) >= 0
  );
};

const placeCaretAtEnd = (el) => {
  const sel = window.getSelection();
  if (!sel) return;
  const range = document.createRange();
  range.selectNodeContents(el);
  range.collapse(false);
  sel.removeAllRanges();
  sel.addRange(range);
};

/**
 * Insert code HTML at the current selection without execCommand('insertHTML').
 * Full replace assigns `innerHTML` once; otherwise delete + insert a fragment.
 * Both beat Chromium's selected-range insertHTML on large / formerly BR-heavy trees.
 */
export const insertCodeHtmlAtSelection = (el, html) => {
  const sel = window.getSelection();
  if (!sel) {
    el.innerHTML = html;
    return;
  }

  let range = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
  if (!range || !el.contains(range.commonAncestorContainer)) {
    el.focus({ preventScroll: true });
    range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
  }

  const emptyEditable = !(el.textContent || '').length;
  if (selectionCoversEntireEditable(el) || (emptyEditable && range.collapsed)) {
    el.innerHTML = html;
    placeCaretAtEnd(el);
    return;
  }

  range.deleteContents();
  const template = document.createElement('template');
  template.innerHTML = html;
  const frag = template.content;
  const last = frag.lastChild;
  range.insertNode(frag);
  if (last) {
    range.setStartAfter(last);
    range.collapse(true);
    sel.removeAllRanges();
    sel.addRange(range);
  }
};
